<template>
  <div class="d-flex flex-column align-items-center justify-content-center h-100">
    <div class="spinner-border cirx-custom-primary-color" style="width: 3rem; height: 3rem"></div>
    <div class="my-5">{{ loadingMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "InCardLoader",

  props: {
    loadingMessage: { type: String, required: true },
  },
};
</script>

<style scoped></style>
